import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Select from 'react-select';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useCustomSnackbar } from '../hooks/useCustomSneakbar';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';

const CreateUser = () => {
    const authorizedAxios = generateAxiosInstance()
    const initialFormState = {
        // userUniqueId: '',
        email: '',
        password: '',
        phone: '',
        userType: 'A',
        status: 'A',
        userRole: ''
    }
    const [createUser, setCreateUser] = useState(initialFormState)
    const [userCredentials, setUserCredentials] = useState([])
    const [editId, setEditId] = useState(null)
    const [showPassword, setShowPassword] = useState([]);
    const [refreshList, setRefreshList] = useState(false)
    const [openErrorSnackbar] = useCustomSnackbar('error')
    const [openSuccessSnackbar] = useCustomSnackbar('success')

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [userIdSort, setUserIdSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["userUniqueId", "email", "phone", "userRole"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getUserCredentials();
    }, [refreshList, refresh]);

    const getUserCredentials = async () => {
        try {
            const apiUrl = `/get-create-user`;
            const response = await authorizedAxios.get(apiUrl);
            setUserCredentials(response.data.result);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setUserCredentials(await searchArray("A", '/get-create-user', searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(userCredentials, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(userCredentials.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > userCredentials.length) {
            endIndex = userCredentials.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(userCredentials.slice(startIndex, endIndex));
    }, [userCredentials, currPage, itemsPerPage]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCreateUser((prevData) => {
            if (name == 'phone' && value.length > 10) {
                return {
                    ...prevData,
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value,
                }
            }
        })
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        // Exclude validation for userType and status fields
        const fieldsToValidate = Object.keys(createUser).filter(key => key !== 'userType' && key !== 'status');
        const contactNumberValid = createUser.phone.length == 10;
        return Object.values(error).every((error) => error === '') &&
            fieldsToValidate.every((key) => typeof (createUser[key]) === "string" ? createUser[key] !== '' : createUser[key].length !== 0) && contactNumberValid;
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(createUser)) {
                if (key !== 'userType' && key !== 'status') { // Exclude userType and status fields
                    if (key == 'phone' && value.length > 0 && value.length < 10) {
                        setError((prevData) => ({
                            ...prevData,
                            phone: 'Contact number must be at least 10 characters long.',
                        }));
                    } else if (value === '' || value.length === 0) {
                        setError((prevData) => ({
                            ...prevData,
                            [key]: 'This field is required.',
                        }));
                    } else {
                        setError((prevData) => ({
                            ...prevData,
                            [key]: '',
                        }));
                    }
                }
            }
        }
    }, [createUser]);

    const createNewUser = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-create-user`;
                const response = await authorizedAxios.post(apiUrl, createUser);
                await getUserCredentials();
                setCreateUser(initialFormState);
                setError(initialErrorState);
                setSaveId(response.data.result.id);
                setUserIdSort(null);
                setEmailSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(createUser)) {
                if (key !== 'userType' && key !== 'status') {
                    if (key == 'phone' && value.length > 0 && value.length < 10) {
                        setError((prevData) => ({
                            ...prevData,
                            phone: 'Contact number must be at least 10 characters long.',
                        }));
                    } else if (createUser[key] == '' || value.length === 0) {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: 'This field is required.',
                            }
                        })
                    } else {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: '',
                            }
                        })
                    }
                }
            }
        }
    }

    const togglePasswordVisibility = (index) => {
        setShowPassword(prevState => {
            const updatedShowPassword = [...prevState];
            updatedShowPassword[index] = !updatedShowPassword[index];
            return updatedShowPassword;
        });
    };

    const changeActive = (id) => {
        setLoading(true);
        const apiUrl = `/permission-create-user?id=${id}`;
        authorizedAxios && authorizedAxios.patch(apiUrl)
            .then(response => {
                setRefreshList(!refreshList)
                setTimeout(() => {
                    Swal.fire({ text: response.data.message });
                }, 100);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const sendMail = (email, userId, password) => {
        setLoading(true);
        const data = {
            email: email,
            userId: userId,
            password: password
        };

        const apiUrl = `/send-mail-create-user`;
        authorizedAxios && authorizedAxios.post(apiUrl, data)
            .then(response => {
                setTimeout(() => {
                    Swal.fire({ text: response.data.message });
                }, 100);

            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    useEffect(() => {
        if (userIdSort == true || userIdSort == false) {
            setEmailSort(null);
        }
    }, [userIdSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setUserIdSort(null);
        }
    }, [emailSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Create User </span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-user"></i> Create User </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="email" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Email :</label>
                                                    <input required type="email" id='email' className="form-control" name="email" value={createUser.email} onChange={handleInputChange} />

                                                    {error.email && <p style={{ color: 'red' }}>{error.email}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="password" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Password :</label>
                                                    <input required type="password" id='password' className="form-control" name="password" value={createUser.password} onChange={handleInputChange} />

                                                    {error.password && <p style={{ color: 'red' }}>{error.password}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="phone" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Contact Number :</label>
                                                    <input required type="number" id='phone' className="form-control custom-input" name="phone" value={createUser.phone} onChange={handleInputChange} />

                                                    {error.phone && <p style={{ color: 'red' }}>{error.phone}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="userRole" className="col-form-label"><span style={{ color: "red" }}>*</span>Select User Role :</label>
                                                    <select class="form-select" id='userRole' aria-label="Default select example" name='userRole' onChange={handleInputChange} value={createUser.userRole}>
                                                        <option selected value={''} disabled>Select Role</option>
                                                        <option value={"DEO"}>{"DEO"}</option>
                                                    </select>
                                                    {error.userRole && <p style={{ color: 'red' }}>{error.userRole}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId &&
                                                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={createNewUser}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setEditId(''); setCreateUser(initialFormState); setError(initialErrorState) }}>Reset</button>
                                                        {/* {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateUser} disabled={!editId}>Update</button>)
                                                        } */}
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width ">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            User Id
                                                                            <SortIcon sortState={userIdSort} setSortState={setUserIdSort} setData={setUserCredentials} setCurrPage={setCurrPage} sortingPath={"userUniqueId"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Email
                                                                            <SortIcon sortState={emailSort} setSortState={setEmailSort} setData={setUserCredentials} setCurrPage={setCurrPage} sortingPath={"email"} />
                                                                        </th>
                                                                        <th scope="col">Password</th>
                                                                        <th scope="col">Contact Number</th>
                                                                        <th scope="col">Role </th>
                                                                        <th scope="col">Active/Inactive</th>
                                                                        <th scope="col">Send Mail</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((user, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{user?.userUniqueId}</td>
                                                                                        <td>{user?.email}</td>
                                                                                        <td>{showPassword[index] ? (user?.password) : ('••••••••')}
                                                                                            <button
                                                                                                className="btn btn-link"
                                                                                                type="button"
                                                                                                onClick={() => togglePasswordVisibility(index)}
                                                                                            >
                                                                                                <i className={`fa ${showPassword[index] ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                                                                            </button>
                                                                                        </td>
                                                                                        <td>{user?.phone}</td>
                                                                                        <td>{user?.userRole}</td>
                                                                                        <td>
                                                                                            <div className={`toggle-container ${user.isActive ? 'active' : ''}`} onClick={() => changeActive(user.id)}>
                                                                                                <div className="toggle-background"></div>
                                                                                                <div className="toggle-switch"></div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-info" type="button" onClick={() => sendMail(user.email, user.userUniqueId, user.password)}>
                                                                                                <i className="fa fa-paper-plane"></i>
                                                                                            </button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center', padding: "50px" }}>No user Structure Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={userCredentials.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default CreateUser;